import React from "react";
import "./ThemedTag.scss";

export type ThemedTagType = "success" | "error" | "neutral";

export interface ThemedTagProps {
    text: string;
    type: ThemedTagType;
}

const ThemedTag: React.FC<ThemedTagProps> = ({ text, type }) => {
    return (
        <div className={`themed-tag themed-tag--${type}`}>
            <span className={`themed-tag__text themed-tag__text--${type}`}>{text}</span>
        </div>
    );
};

export default ThemedTag;
